// Module
var code = "<div class=\"sl-exercice\"> <div class=\"ecran\"> <iframe id=\"exercice-frame\"></iframe> </div> </div> ";
// Exports
module.exports = code;